import missingFamilyListSaga from 'modules/MissingFamily/saga/list';
import missingFamilyDetailsSaga from 'modules/MissingFamily/saga/details';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* missingFamilySaga(): SagaIterator {
  yield fork(missingFamilyListSaga);
  yield fork(missingFamilyDetailsSaga);
}
